import { ErrorModel } from "./errorModel";

export class SellInModel {
    idDistribuidor: string;
    anio: number;
    mes: number;
    articulo: string;
    contenedor: string;
    presupuestoKilo: number;
    presupuestoCaja: number;
    presupuestoImporte: number;
    error?: ErrorModel;
    correct?: boolean;

    constructor() { }

    devolverModeloGridSellin() {
        const objeto: SellInModelInterface = {
            idDistribuidor: 'idDistribuidor',
            anio: 'anio',
            mes: 'mes',
            articulo: 'articulo',
            contenedor: 'contenedor',
            presupuestoKilo: 'presupuestoKilo',
            presupuestoCaja: 'presupuestoCaja',
            presupuestoImporte: 'presupuestoImporte',
            error: 'error',
            correct: 'correct'
        }
        return objeto;
    }
}

export interface SellInModelInterface {
    idDistribuidor: string;
    anio: string;
    mes: string;
    articulo: string;
    contenedor: string;
    presupuestoKilo: string;
    presupuestoCaja: string;
    presupuestoImporte: string;
    error: string;
    correct: string;
}